import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MENU_STRUCTURE } from '../data';

export default function Sidebar() {
  const location = useLocation();
  const path = location.pathname;

  // Flatten the menu structure to find the direct parent section for the sidebar
  // (e.g. "Om Vester-Bo", "Vester-Bo tilbyder", "Fysiske rammer", "Medarbejdere")
  const sidebarSections = [];
  MENU_STRUCTURE.forEach(item => {
    if (item.isMega) {
      sidebarSections.push(...item.children);
    } else {
      sidebarSections.push(item);
    }
  });

  // Find the active section that is either the current path or contains it as a child
  const activeSection = sidebarSections.find(section => 
    section.href === path || (section.children && section.children.some(child => child.href === path))
  );

  if (!activeSection || !activeSection.children || activeSection.children.length === 0) {
    return null;
  }

  return (
    <aside className="w-full lg:w-72 flex-shrink-0">
      <div className="bg-slate-50 rounded-2xl p-6 border border-slate-100/80 sticky top-8">
        <h3 className="font-serif text-lg font-bold text-secondary mb-4 pb-3 border-b border-slate-200/60">
          {activeSection.label}
        </h3>
        <nav className="space-y-1.5">
          <Link
            to={activeSection.href}
            className={`block px-4 py-2.5 rounded-xl text-sm font-medium transition-colors ${
              path === activeSection.href 
                ? 'text-primary bg-teal-50/60 font-semibold border-l-4 border-primary pl-3' 
                : 'text-slate-600 hover:text-primary hover:bg-slate-100/50'
            }`}
          >
            Oversigt
          </Link>
          {activeSection.children.map((child) => (
            <Link
              key={child.label}
              to={child.href}
              className={`block px-4 py-2.5 rounded-xl text-sm font-medium transition-colors ${
                path === child.href 
                  ? 'text-primary bg-teal-50/60 font-semibold border-l-4 border-primary pl-3' 
                  : 'text-slate-600 hover:text-primary hover:bg-slate-100/50'
              }`}
            >
              {child.label}
            </Link>
          ))}
        </nav>
      </div>
    </aside>
  );
}
